
document.addEventListener("DOMContentLoaded", function () {

  // ------------------ GLOBAL HELPERS ------------------
  function getErrorEl(field) {
    let err = document.getElementById("error-" + field.id);
    if (!err) {
      err = document.createElement("div");
      err.className = "field-error";
      err.id = "error-" + field.id;
      err.style.color = "#d00";
      err.style.fontSize = "13px";
      err.style.marginTop = "4px";
      err.setAttribute("aria-live", "polite");
      field.insertAdjacentElement("afterend", err);
    }
    return err;
  }

  function setError(field, msg) {
    const el = getErrorEl(field);
    el.textContent = msg;
    el.style.display = "block";
    field.setAttribute("aria-invalid", "true");
    return false;
  }

  function clearError(field) {
    const el = getErrorEl(field);
    el.textContent = "";
    el.style.display = "none";
    field.removeAttribute("aria-invalid");
    return true;
  }

  function scrollToError(form) {
    const err = form.querySelector(".field-error[style*='block']");
    if (err) {
      const input = err.previousElementSibling;
      if (input) {
        input.scrollIntoView({ behavior: "smooth", block: "center" });
        input.focus();
      }
    }
  }

  const urlLikePattern = /(https?:\/\/|www\.)/i;
  const forbiddenMessageChars = /[<>{}]/;

  // ------------------ FIELD VALIDATORS ------------------
  function validateName(field, fieldName) {
    const raw = field.value || '';
    if (!raw || raw.trim() === '') return setError(field, fieldName + ' is required.');
    if (/^\s/.test(raw)) return setError(field, '');
    if (urlLikePattern.test(raw)) return setError(field, 'URLs are not allowed.');
    if (/[^A-Za-z\s]/.test(raw)) return setError(field, '');
    if (/\s{2,}/.test(raw)) return setError(field, '');
    const wordCount = raw.trim().split(/\s+/).filter(Boolean).length;
    if (wordCount > 250) return setError(field, 'Cannot exceed 250 words.');
    return clearError(field);
  }

  function validateEmail(field) {
    const raw = field.value || '';
    if (!raw || raw.trim() === '') return setError(field, 'Email is required.');
    if (/\s/.test(raw)) return setError(field, 'No spaces allowed.');
    if (urlLikePattern.test(raw)) return setError(field, 'Full URLs are not allowed.');
    // ✅ Numbers now allowed in email:
    const emailPattern = /^[A-Za-z0-9._%+\-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    if (!emailPattern.test(raw)) return setError(field, '.');
    return clearError(field);
  }

  function validatePassword(field) {
    const raw = field.value || ''; // keep spaces for validation
    if (!raw) return setError(field, 'Password is required.');
    if (/\s/.test(raw)) return setError(field, 'Password cannot contain spaces.'); // ❌ disallow spaces
    if (raw.length < 6) return setError(field, 'Password must be at least 6 characters.');
    return clearError(field);
  }
  

  function validatePhone(field) {
    const raw = field.value || '';
    if (!raw || raw.trim() === '') return setError(field, 'Phone number is required.');
    if (/\s/.test(raw)) return setError(field, 'No spaces allowed.');
    if (!/^[0-9]+$/.test(raw)) return setError(field, 'Only digits allowed.');
    if (raw.length < 10 || raw.length > 15) return setError(field, 'Phone must be 10–15 digits.');
    return clearError(field);
  }

  // ------------------ PREVENT COPY/PASTE ------------------
  function preventCopyPaste(fields) {
    fields.forEach(field => {
      if (!field) return;
      field.setAttribute("autocomplete", "off");
      ["paste", "copy", "cut"].forEach(evt => {
        field.addEventListener(evt, function (e) {
          e.preventDefault();
          const err = getErrorEl(field);
          err.textContent = '';
          err.style.display = 'block';
          field.focus();
          setTimeout(() => { clearError(field); }, 2200);
        });
      });
      field.addEventListener('drop', e => e.preventDefault());
    });
  }

  // ------------------ REAL-TIME RESTRICTIONS ------------------
  function applyInputRestrictions(field, type) {
    if (!field) return;
    if (type === "name") {
      field.addEventListener("input", function () {
        this.value = this.value.replace(/[^A-Za-z\s]/g, "");
      });
    } else if (type === "email") {
      // ✅ Allow numbers now
      field.addEventListener("input", function () {
        this.value = this.value.replace(/[^A-Za-z0-9@._\-+]/g, "");
      });
    }
  }

  // ------------------ APPLY TO LOGIN FORM ------------------
  // const loginForm = document.getElementById("customer_login");
  // if (loginForm) {
  //   const email = document.getElementById("CustomerEmail");
  //   const pass = document.getElementById("CustomerPassword");
  //   preventCopyPaste([email, pass]);
  //   applyInputRestrictions(email, "email");

  //   loginForm.addEventListener("submit", e => {
  //     const v1 = validateEmail(email);
  //     const v2 = validatePassword(pass);
  //     if (!(v1 && v2)) { e.preventDefault(); scrollToError(loginForm); }
  //   });

  //   [email, pass].forEach(f => f.addEventListener("blur", () => {
  //     if (f === email) validateEmail(f);
  //     else validatePassword(f);
  //   }));
  //   [email, pass].forEach(f => f.addEventListener("input", () => {
  //     if (f === email) validateEmail(f);
  //     else validatePassword(f);
  //   }));
  // }

  // ------------------ APPLY TO RECOVER PASSWORD FORM ------------------
  const recoverForm = document.querySelector('form[action="/account/recover"]');
  if (recoverForm) {
    const recoverEmail = document.getElementById("RecoverEmail");
    preventCopyPaste([recoverEmail]);
    applyInputRestrictions(recoverEmail, "email");

    recoverForm.addEventListener("submit", e => {
      const valid = validateEmail(recoverEmail);
      if (!valid) { 
        e.preventDefault();
        scrollToError(recoverForm);
      }
    });

    recoverEmail.addEventListener("blur", () => validateEmail(recoverEmail));
    recoverEmail.addEventListener("input", () => validateEmail(recoverEmail));
  }

  // ------------------ APPLY TO CREATE ACCOUNT ------------------
  const createForm = document.getElementById("create_customer");
  if (createForm) {
    const fName = document.getElementById("RegisterForm-FirstName");
    const lName = document.getElementById("RegisterForm-LastName");
    const email = document.getElementById("RegisterForm-email");
    const pass = document.getElementById("RegisterForm-password");
    preventCopyPaste([fName, lName, email, pass]);
    applyInputRestrictions(fName, "name");
    applyInputRestrictions(lName, "name");
    applyInputRestrictions(email, "email");

    createForm.addEventListener("submit", e => {
      const v1 = validateName(fName, "First name");
      const v2 = validateName(lName, "Last name");
      const v3 = validateEmail(email);
      const v4 = validatePassword(pass);
      if (!(v1 && v2 && v3 && v4)) { e.preventDefault(); scrollToError(createForm); }
    });

    [fName, lName, email, pass].forEach(f => {
      f.addEventListener("blur", () => {
        if (f === email) validateEmail(f);
        else if (f === pass) validatePassword(f);
        else validateName(f, (f.labels?.[0]?.textContent.replace('*', '').trim()) || "Field");
      });
      f.addEventListener("input", () => {
        if (f === email) validateEmail(f);
        else if (f === pass) validatePassword(f);
        else validateName(f, (f.labels?.[0]?.textContent.replace('*', '').trim()) || "Field");
      });
    });
  }

  // ------------------ APPLY TO ADDRESS FORMS ------------------
  const addressForms = document.querySelectorAll("form[id^='AddressForm_']");
  addressForms.forEach(form => {
    const fName = form.querySelector("[id*='FirstName']");
    const lName = form.querySelector("[id*='LastName']");
    const address1 = form.querySelector("[id*='Address1']");
    const city = form.querySelector("[id*='City']");
    const zip = form.querySelector("[id*='Zip']");
    const phone = form.querySelector("[id*='Phone']");
    preventCopyPaste([fName, lName, address1, city, zip, phone]);
    applyInputRestrictions(fName, "name");
    applyInputRestrictions(lName, "name");

    form.addEventListener("submit", e => {
      let valid = true;
      if (fName) valid &= validateName(fName, "First name");
      if (lName) valid &= validateName(lName, "Last name");
      if (address1) valid &= validateName(address1, "Address");
      if (city) valid &= validateName(city, "City");
      if (zip) valid &= validateName(zip, "Postal code");
      if (phone) valid &= validatePhone(phone);

      if (!valid) { e.preventDefault(); scrollToError(form); }
    });

    [fName, lName, address1, city, zip, phone].forEach(f => {
      if (!f) return;
      f.addEventListener("blur", () => {
        if (f === phone) validatePhone(f);
        else validateName(f, f.labels?.[0]?.textContent || "Field");
      });
      f.addEventListener("input", () => {
        if (f === phone) validatePhone(f);
        else validateName(f, f.labels?.[0]?.textContent || "Field");
      });
    });
  });

});
